export default class DtoGeoApiTown {
    constructor(obj) {
        this.code = obj.code
        this.name = obj.nom
    }
}